import { css } from '@emotion/core';
import { faSpinner } from '@fortawesome/pro-regular-svg-icons/faSpinner';
import Icon from '@veeva/corgix/icon';
import useMessageService from '../../services/i18n/useMessageService';

const UsernameVerifiedConfirmation = () => {
    const [
        [
            emailVerified = 'Your email has been verified and is being updated. Please do not close this page.',
        ],
    ] = useMessageService(['username.email_verified']);

    return (
        <div
            css={({ lighterGray }) =>
                css`
                    display: flex;
                    flex-direction: column;
                    text-align: center;
                    align-items: center;
                    justify-content: center;
                    gap: 1.667rem;
                    color: ${lighterGray};
                `
            }
        >
            <Icon spin type={faSpinner} size="xl" />
            <span>{emailVerified}</span>
        </div>
    );
};

export default UsernameVerifiedConfirmation;
